import { supabase } from './supabase';
import { localDateStr } from './date';

// Cek apakah ada PO batch yang sedang buka untuk dipesan hari ini/ke depan.
// Kalau ADA  -> web tampilkan produk PO (batch, kuota, area, tanggal kirim).
// Kalau TIDAK -> web tampilkan menu POS reguler (order langsung, disiapkan dapur).
export async function getActivePO() {
  const today = localDateStr();
  const { data } = await supabase
    .from('po_batches')
    .select('*, product:products(*, product_variants(*)), area:areas(name)')
    .eq('status', 'open')
    .gte('date', today)
    .order('date', { ascending: true })
    .limit(1)
    .maybeSingle();
  return data || null;
}
